<template lang="pug">
div
  v-card.rounded-lg(flat v-if="themes && themes.length > 0 && selectedTheme")
        v-card-title {{$t('create.setClips.title')}}
        v-card-subtitle {{$t('create.setClips.subtitle')}}
        
        v-card-text
          v-checkbox(v-if="selectedTheme.addAudio && !selectedTheme.excludeIntro" v-model="motionDraft.inlcudeAudioForClips" rounded dense :label="$t('create.forms.backgroundMusic')")
          div(v-if="(includeIntro && !selectedTheme.excludeIntro) || overlay")
            
            v-text-field.rounded-lg(v-model='motionDraft.introTitle', dense rounded v-if="includeIntro && !selectedTheme.excludeIntro" :counter='60', :rules='nameRules', :label="$t('create.forms.introText')", filled)
            div(v-if="overlay")
              div( v-for="input in overlay.params"  :key="input.key") 
                v-text-field.rounded-lg(v-if="input.type !== undefined && input.type !== null && input.type !== 'textarea'" :type="input.type" @input="updateOverlay" v-model="input.value" :name="input.key" :label="getLabel(input)" dense filled rounded)
                v-textarea.rounded-lg(v-if="input.type !== undefined && input.type !== null && input.type == 'textarea'" :counter="input.maxLength" :rules="[v => (v || '' ).length <= input.maxLength || `${getLabel(input)} darf max. 200 Zeichen sein`]" dense no-resize @input="updateOverlay" v-model="input.value" :name="input.key" :label="getLabel(input)" filled rounded)

          
  div(v-else style="height: 100%; width: 100%; min-width: 100px; min-height: 300px" )
    v-skeleton-loader( style="opacity: 1; height: 100%; width: 100%; min-width: 100px; min-height: 300px" type="image"  min-height="300")
</template>

<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import { nameRules, descriptionRules } from "@/utils/validations";

export default {
  name: "MotionConfigForm",
  data() {
    return {
      nameRules,
      descriptionRules,
    };
  },
  computed: {
    ...mapFields("create", {
      includeIntro: "motionSettings.includeIntro",
      selectedTheme: "selectedTheme",
      overlay: "selectedTheme.overlay",
      motionDraft: "motionDraft",
    }),
    ...mapState({
      categories: (state) => state.settings.categories,
      themes: (state) => state.create.themes,
    }),
  },

  methods: {
    updateOverlay() {
      this.$emit("updateOverlay", this.selectedTheme.overlay);
    },
    getLabel(input) {
      const translations = input.translation;

      if (!translations) {
        return this.$i18n.t(`general.${input.key.toLowerCase()}`);
      } else {
        const currentLocale = this.$i18n.locale;
        return translations[currentLocale];
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.v-skeleton-loader
  width: 100%
  height: 100%
.v-skeleton-loader__bone
    position: static
.v-skeleton-loader__image
    height: 100%
    width: 100%
</style>
